/* Publish by EComposer at 2025-08-04 18:56:38*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kyzub6atcc"]=  window.__ectimmers["ecom-kyzub6atcc"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kyzub6atcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyzub6atcc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e9fyemj05t"]=  window.__ectimmers["ecom-e9fyemj05t"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-e9fyemj05t"]["pw0elzioy"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-e9fyemj05t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e9fyemj05t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fiebg85mbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fiebg85mbw', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y0m8nr9318n"]=  window.__ectimmers["ecom-y0m8nr9318n"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-y0m8nr9318n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0m8nr9318n', settings: {"link":"lightbox","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9lr38oku5yv"]=  window.__ectimmers["ecom-9lr38oku5yv"] || {};
if(!this.settings||!this.$el||this.isLive)return;const e=this.$el;let i=e.querySelectorAll('script:not([type="application/json"])');i.length>0&&i.forEach(function(t){let n=document.createElement("script");n.type="text/javascript",n.innerText=t.innerText,t.src&&(n.src=t.src),e.appendChild(n),t.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-9lr38oku5yv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lr38oku5yv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgxenp6tq8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgxenp6tq8m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0kl74n2hr8x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0kl74n2hr8x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0jwooceg96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0jwooceg96', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}